import React from 'react';

// Standard below-button consent copy (WEBDEV-3888). Reads as a new sentence after the Terms
// link, hence the ". " separator. Also the component default, so a form that renders
// <ConsentMsg /> without props gets the current legal copy rather than stale wording.
export const SMS_CONSENT_LEGAL_TERMS = (
    <>
        I consent to Milan's info and promo emails, texts, and calls, which may be automated, prerecorded, or AI.
        Consent to contact is not a purchase condition. Frequency varies. Msg & data rates may apply. STOP to end. HELP
        for help.
    </>
);

export function ConsentMsg({
    cta = 'Submit<sup>*</sup>',
    legalTerms = SMS_CONSENT_LEGAL_TERMS,
    separator = '. ',
    termsLabel = 'Terms',
}) {
    return (
        <small className="lh-1">
            By clicking <span dangerouslySetInnerHTML={{ __html: cta }} />, I agree to the{' '}
            <a
                href="https://milanlaser.com/privacy"
                target="_blank"
                rel="noreferrer"
                className="text-decoration-underline fw-bold"
            >
                Privacy Policy
            </a>{' '}
            and{' '}
            <a
                href="https://milanlaser.com/terms"
                target="_blank"
                rel="noreferrer"
                className="text-decoration-underline fw-bold"
            >
                {termsLabel}
            </a>
            {separator}
            {legalTerms}
        </small>
    );
}

export default ConsentMsg;
